export default __webpack_public_path__ + "static/media/cont.4475a3e9.jpg";